module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vue-color__c-hue', _vm.directionClass]
  }, [_c('div', {
    ref: "container",
    staticClass: "vue-color__c-hue__container",
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vue-color__c-hue__pointer",
    style: ({
      top: _vm.pointerTop,
      left: _vm.pointerLeft
    })
  }, [_c('div', {
    staticClass: "vue-color__c-hue__picker"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b1ceebe!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/Hue.vue
// module id = 304
// module chunks = 1